import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { EMPLOYMENT_STATUS_OPTIONS } from '@/services/user/constant'
import { queryUserExperience } from '@/services/user/query'

import { KeyValue } from '@/components/ui/key-value'

import { formatMonthYear } from '@/lib/utils/utils'

export const Route = createFileRoute('/dashboard/experience')({
  component: RouteComponent,
})

function RouteComponent() {
  const experienceQry = useSuspenseQuery(queryUserExperience())
  const experiences = experienceQry.data
  return (
    <div className="rounded-lg border-t-4 border-yes-600 bg-background">
      <div className="border-b px-4 py-4">
        <h2 className="font-semibold">Riwayat Pekerjaan</h2>
      </div>
      <div className="divide-y divide-gray-200 px-4">
        {experiences?.map(
          ({
            id,
            title,
            company_name,
            employment_type,
            start_date,
            end_date,
            description,
          }) => {
            let dateStr = ''
            if (start_date) dateStr += formatMonthYear(start_date)
            dateStr += ' - '
            if (end_date) dateStr += formatMonthYear(end_date)
            else dateStr += 'Sekarang'

            const employmentTypeStr =
              EMPLOYMENT_STATUS_OPTIONS.find(
                (y) => y.value === employment_type?.toUpperCase()
              )?.label || '-'

            return (
              <div key={id} className="grid grid-cols-2 gap-4 py-4">
                <KeyValue
                  label="Jabatan"
                  value={title}
                  className="col-span-full"
                />
                <KeyValue
                  label="Nama Perusahaan"
                  value={company_name}
                  className="col-span-full"
                />
                <KeyValue
                  label="Status Karyawan"
                  value={employmentTypeStr}
                  className="col-span-full"
                />
                <KeyValue
                  label="Tanggal Mulai - Selesai"
                  value={dateStr}
                  className="col-span-full"
                />
                <KeyValue
                  label="Deskripsi Pekerjaan"
                  value={description || '-'}
                  className="col-span-full"
                />
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}
